import React from 'react'
import _cx from 'classnames/bind'
import PropTypes from 'prop-types'
import { Icon, Text } from '@adc/ui-adc'
import { getBidHistoryForListing } from 'common/providers/listing'
import { BiddingHistoryModal } from './modal'
import cls from './styles.scss'

// TODO: change this whole file to typescript

const cx = _cx.bind(cls)

export const TRIGGER_TEXT = 'Bid History'
const defaultTrigger = (
  <div className={cx('bid-history-cta', 'u-pointer-cursor')}>
    <Icon color='info' name='history' size='large' fitted />
    <Text color='info' size='small' className='u-ml-1' tabIndex='0'>
      {TRIGGER_TEXT}
    </Text>
  </div>
)
export default class BidHistory extends React.Component {
  static propTypes = {
    listing: PropTypes.object.isRequired,
    trigger: PropTypes.element,
  }

  static defaultProps = {
    trigger: defaultTrigger,
  }

  state = {
    biddingHistory: [],
    isHistoryOpen: false,
  }

  showBiddingHistory = async () => {
    /*
    resp format will be: 
    [
    {
        "bid_amount": 351000,
        "belongs_to_current_user": true,
        "type": "REGULAR",
        "bid_id": "7822554"
    },
    {
        "bid_amount": 350000,
        "belongs_to_current_user": false,
        "type": "MAX_BID",
        "bid_id": "7822488"
    },
    {
        "bid_amount": 350000,
        "belongs_to_current_user": true,
        "type": "MAX_BID",
        "bid_id": "7822487"
    },
    {
        "bid_amount": 125000,
        "belongs_to_current_user": false,
        "type": "MAX_BID",
        "bid_id": "7822486"
    }
]
    */
    getBidHistoryForListing(null, this.props.listing.listing_id).then(resp => {
      this.setState({
        isHistoryOpen: true,
        biddingHistory: resp,
      })
    })
  }

  hideBiddingHistory = e => {
    this.setState({
      isHistoryOpen: false,
    })
  }

  render() {
    const trigger = React.cloneElement(this.props.trigger, {
      'data-elm-id': 'bid_history_target',
      onClick: this.showBiddingHistory,
    })
    return (
      <>
        {trigger}
        <BiddingHistoryModal
          biddingHistory={this.state.biddingHistory}
          listing={this.props.listing}
          onClose={this.hideBiddingHistory}
          open={this.state.isHistoryOpen}
        />
      </>
    )
  }
}
